import store from '../../init/store.js'
import {sendViewConfirmationToServer} from '../connection/firebase.js'
import {getUpdatedBattleState} from './start-turn-series.js'
import {setBattleValue} from '../../redux-actions/battle-actions.js'
import {offlineCheckForAutoSubmission} from '../offline/offline-check-for-auto-submissions.js'

/** Do something once the current rollout has been SEEN and state changes APPLIED */
export function handleSeenRollout() {

  //Get the person who submitted this so we can add to our list of 'seriesTurnsSubmitters'
  const lastSubmitterId = store.getState().battle.rolloutHistory[0].submitterCombatantId;


  //Clear the arena view submission menu (for Arena view)
  setBattleValue({
    arenaIsRolloutShowing: false,
    arenaSubmissionMenuAction: null,
    arenaSubmissionMenuTargets: null,
    arenaSubmissionIsSubmitted: false,

    //Record the person that submitted this (so we can visualize)
    seriesTurnsSubmitters: [
      ...store.getState().battle.seriesTurnsSubmitters,
      lastSubmitterId
    ]
  });



    //Case 1: Multiplayer!
    if (store.getState().battle.isMultiplayerMode) {
      sendViewConfirmationToServer();
    } else {

    //Case 2: Offline play!
      const nextBattleState = getUpdatedBattleState(); //Get the next state

      setBattleValue({
        ...nextBattleState
      });

      //Check for offlineBot submission
      offlineCheckForAutoSubmission(); //This will select for an offline bot if we're waiting on somebody.
    }


}


// WEBPACK FOOTER //
// ./src/battle/lifecycle/handle-seen-rollout.js